import { HeroBannerProps } from "./HeroBanner.types";
import bg from "../../assets/agendaBg.png";
import {
  CONTENT_TYPE,
  LEVEL
} from "../../consts";

export const Default: HeroBannerProps = {
  booked:false,
  categories: ["finanza", "tecnologia"],
  coverPublicURL:bg,
  duration: 1 * 60 * 60,
  ecm_specialization:false,
  ecmRegistration:false,
  enrollType:"AUTO_ENROLL",
  id: 5,
  isEnable: true,
  isFavourite:false,
  isMandatory:false,
  isSurvey:false,
  isTest:false,
  learningObjectType: CONTENT_TYPE.SYNC,
  learningObjectTypology: LEVEL.DA_EXTERNAL_RES,
  meetingDetails:[{
    endDate:"20-03-2024",
    meetingNumber:2,
    startDate:"20-03-2024"
  }],
  percentageOfCompletion: "34%",
  rating:0,
  setOpenModalEcm:()=>true,
  shortDescription: "Migliora le tue competenze di apprendimento e preparati ad affrontare le sfide del futuro!",
  status:"N",
  title: "Investimenti e strategie",
  canAccessNow: true,
  link: "",
  isLinkRelative:false
};
